'use client';

import { c as _c } from "react/compiler-runtime";
import { CreateProjectOnboarding } from '@/domains/onboarding/components/create-project-onboarding/create-project-onboarding';
export default function OnboardingPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CreateProjectOnboarding />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}